export class ShowColumn {
  static readonly type = '[View] Show Column';
  constructor(public show: boolean) { }
}

export class ShowPanel {
  static readonly type = '[View] Show Panel';
  constructor(public show: boolean) { }
}

export class CollapsePanel {
  static readonly type = '[View] Collapse Panel';
  constructor(public collapse: boolean) { }
}

export class ResetView {
  static readonly type = '[View] Reset';
  constructor() { }
}
